import styled from "styled-components";
import { COLOR_BLACK, COLOR_WHITE } from "../constants/colors";
import SocialMedias from "./SocialMedias";
import { Subtitle1, Subtitle2 } from "./Typography";

const StyledFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${COLOR_BLACK};
`;

const Title = styled.div`
  ${Subtitle1}
  color: ${COLOR_WHITE};
  text-align: center;

  @media only screen and (max-width: 400px) {
    max-width: 75%;
  }
`;

const Subtitle = styled.div`
  ${Subtitle2}
  color: ${COLOR_WHITE};
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Link = styled.a`
  font-weight: 600;
`;

function Footer() {
  return (
    <StyledFooter className="py-5 px-3">
      <Title>Contact us now to join this exclusive club.</Title>
      <span>
        <br />
      </span>
      <Subtitle>
        <span>
          Say hello{" "}
          <Link href="mailto:info@beartiger.io" target="_blank" rel="noreferrer">
            Info@beartiger.io
          </Link>
        </span>
         <Link href="https://cdn.beartiger.io/tbtc_course_guide.pdf" target="_blank" rel="noreferrer">
          Course Guide - The Front 9
        </Link>
        <Link href="https://tbtc-merch-shop.s3.us-east-2.amazonaws.com/TBTC_TandC.pdf" target="_blank" rel="noreferrer"> 
          T&amp;C
        </Link>
      </Subtitle>

      <span>
        <br />
      </span>
      <SocialMedias />
    </StyledFooter>
  );
}

export default Footer;
